import React, { useEffect, useState } from 'react'
import Task from './Task';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useDrop } from 'react-dnd';
import NavBarTop from '../NavBarTop';
import LeftNavBar from '../LeftNavBar';
import { timeElapsed } from '../ReusableFunctions';
import { useNavigate } from 'react-router-dom';
import { base_url } from '../../../utilities';
import axios from 'axios';
import Pagination from '../Pagination';
import { RECORDS_PER_PAGE_METER_MASTER } from '../../../Config';
import { useDispatch, useSelector } from 'react-redux';
import TableComponent from '../TableComponent';
import Footer from '../../Login/Footer';
import { commercialHeadGetAllFacilitiesForNav } from '../../../Redux/Actions/Actions';
import Loader from '../loader';

export default function NotificationLogs() {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [isLoading, setIsLoading] = useState(false)

    const [notifacationIconClicked, setNotificationIconClicked] = useState(false)
    const [unredNotificationCount, setUnreadNotificationCount] = useState(0)
    const [userNotificationsColor, setUserNotificationsColor] = useState({
        "Contract": "#33FF57",
        "Invoice": "#FF5733",
        "Meter": "#3357FF",
        "Event": "#FF33A1",
    })

    const [userNotifications, setUserNotifications] = useState([
    ])

    const notificationsDummy = [
        {
            "recipient_id": "55df8665-72f7-46f2-8e53-9fda7c465aee",
            "notification_id": "addbffa2-c45d-4d98-bdfe-02b4af295577",
            "user_id": "716e4316-3f97-49bc-bdf0-7cfa2385c6d9",
            "user_name": "ceo_persona",
            "persona": "CEO",
            "is_read": 0,
            "read_at": null,
            "created_at": "2025-04-09 10:56:08",
            "updated_at": "2025-04-09 10:56:08",
            "created_by": "",
            "updated_by": "",
            "notification_id_1": "addbffa2-c45d-4d98-bdfe-02b4af295577",
            "notification_type": "ContractCreated",
            "service": "Customers",
            "message": "A new contract SpaceHub1 has been created Facility-main1 facility.",
            "entity_type": "FMS Contract",
            "entity_id": "3e46efeb-6a29-4520-a27e-4425d327003e",
            "facility_name": "Facility-main1",
            "facility_id": "76da955c-be2f-48da-8536-919756131cd0",
            "notification_route": "/commercialHeadFMSContracts",
            "created_at_1": "2025-04-09 10:56:08",
            "updated_at_1": "2025-04-09 10:56:08",
            "created_by_1": "",
            "updated_by_1": ""
        },
        {
            "recipient_id": "55df8665-72f7-46f2-8e53-9fda7c465aee",
            "notification_id": "addbffa2-c45d-4d98-bdfe-02b4af295577",
            "user_id": "716e4316-3f97-49bc-bdf0-7cfa2385c6d9",
            "user_name": "ceo_persona",
            "persona": "CEO",
            "is_read": 0,
            "read_at": null,
            "created_at": "2025-04-09 10:56:08",
            "updated_at": "2025-04-09 10:56:08",
            "created_by": "",
            "updated_by": "",
            "notification_id_1": "addbffa2-c45d-4d98-bdfe-02b4af295577",
            "notification_type": "ContractCreated",
            "service": "Customers",
            "message": "A new issues has been raised Facility-main1 facility.",
            "entity_type": "Issue",
            "entity_id": "5637460d-d09d-4daf-b23a-4a0bab2a64af",
            "facility_name": "Facility-main1",
            "facility_id": "76da955c-be2f-48da-8536-919756131cd0",
            "notification_route": "/issuesAndIncidents",
            "created_at_1": "2025-04-09 10:56:08",
            "updated_at_1": "2025-04-09 10:56:08",
            "created_by_1": "",
            "updated_by_1": ""
        },
        {
            "recipient_id": "55df8665-72f7-46f2-8e53-9fda7c465aee",
            "notification_id": "addbffa2-c45d-4d98-bdfe-02b4af295577",
            "user_id": "716e4316-3f97-49bc-bdf0-7cfa2385c6d9",
            "user_name": "ceo_persona",
            "persona": "CEO",
            "is_read": 0,
            "read_at": null,
            "created_at": "2025-04-09 10:56:08",
            "updated_at": "2025-04-09 10:56:08",
            "created_by": "",
            "updated_by": "",
            "notification_id_1": "addbffa2-c45d-4d98-bdfe-02b4af295577",
            "notification_type": "ContractCreated",
            "service": "Customers",
            "message": "A Asset named Asset_8ce3f39f has been created in Facility-main1 facility.",
            "entity_type": "Asset",
            "entity_id": "ba428b29-9be9-4595-931a-515347ef3c2a",
            "facility_name": "Facility-main1",
            "facility_id": "76da955c-be2f-48da-8536-919756131cd0",
            "notification_route": "/FacilityManagerAssetsList",
            "created_at_1": "2025-04-09 10:56:08",
            "updated_at_1": "2025-04-09 10:56:08",
            "created_by_1": "",
            "updated_by_1": ""
        }, {
            "recipient_id": "55df8665-72f7-46f2-8e53-9fda7c465aee",
            "notification_id": "addbffa2-c45d-4d98-bdfe-02b4af295577",
            "user_id": "716e4316-3f97-49bc-bdf0-7cfa2385c6d9",
            "user_name": "ceo_persona",
            "persona": "CEO",
            "is_read": 0,
            "read_at": null,
            "created_at": "2025-04-09 10:56:08",
            "updated_at": "2025-04-09 10:56:08",
            "created_by": "",
            "updated_by": "",
            "notification_id_1": "addbffa2-c45d-4d98-bdfe-02b4af295577",
            "notification_type": "ContractCreated",
            "service": "Customers",
            "message": "You have a new payment for Facility-main1 facility.",
            "entity_type": "Payment",
            "entity_id": "eef47728-9d95-489b-a92d-c4205a5047a8",
            "facility_name": "Facility-main1",
            "facility_id": "76da955c-be2f-48da-8536-919756131cd0",
            "notification_route": "/financeManagerPayments",
            "created_at_1": "2025-04-09 10:56:08",
            "updated_at_1": "2025-04-09 10:56:08",
            "created_by_1": "",
            "updated_by_1": ""
        },
    ]

    // const totalRecords = useSelector((state) => state.allInvoicePayments?.info?.total_no_of_records);
    // const currentPaginationPage = useSelector((state) => state.allInvoicePayments?.info?.page_number);

    const [totalRecords, setTotalRecords] = useState(0)
    const [currentPaginationPage, setCurrentPaginationPage] = useState(1)

    useEffect(() => {
        dispatch(commercialHeadGetAllFacilitiesForNav())
        getNotificationFromBackend()
    }, [dispatch])

    const getNotificationFromBackend = (pageNumber) => {
        setIsLoading(true)
        const userId = localStorage.getItem("user_id")
        axios.get(base_url + `notifications`, {
            params: {
                filter_condition: JSON.stringify({
                    user_id: userId,
                    // is_read: 0,
                }),
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                page_number: pageNumber,
            }
        })
            .then((res) => {
                if (res.status === 200) {
                    const response = res.data.data
                    //  add notificationsDummy to response
                    // response.push(...notificationsDummy)
                    const numberofNotifications = response.length
                    setUserNotifications(response)
                    setUnreadNotificationCount(numberofNotifications)
                    const info = res.data.info
                    setTotalRecords(info.total_no_of_records)
                    setCurrentPaginationPage(info.page_number)
                }
                setIsLoading(false)
            })
            .catch((err) => {
                console.log(err)
                setIsLoading(false)
            })
    }

    const updateNotificationStatus = (notification) => {
        setIsLoading(true)
        const username = localStorage.getItem("username")
        const body = {
            "recipient_id": notification?.recipient_id,
            "is_read": 1,
            "read_at": new Date(),
            "updated_by": username,
        }
        axios.put(base_url + `notifications`, body)
            .then((res) => {
                if (res.status === 200) {
                    setUnreadNotificationCount(unredNotificationCount > 0 ? unredNotificationCount - 1 : 0)
                    navigate(notification?.notification_route, { state: { props: notification } })
                }
                setIsLoading(false)
            })
            .catch((err) => {
                setIsLoading(false)
                console.log(err)
            })

    }

    const handledPaginationNextClicked = () => {

        getNotificationFromBackend(
            currentPaginationPage + 1,
        )
        setCurrentPaginationPage(currentPaginationPage + 1)

    }

    const handledPaginationPrevClicked = () => {
        if (currentPaginationPage > 1) {
            getNotificationFromBackend(
                currentPaginationPage - 1,
            )
            setCurrentPaginationPage(currentPaginationPage - 1)
        }

    }

    const handleEnable = (data) => {
    }



    return (
        <>
            <>
                <NavBarTop />
                <LeftNavBar />
            </>
            <div className='meter_reports_container'>
                <div className='d-flex justify-content-between align-items-center flex-wrap'>
                    <div className='d-flex align-items-center gap-3 mb-3'>
                        <h3 className="invoice-heading" >Notification Logs</h3>
                    </div>


                </div>

                <div className='table_container_commercial_head'>
                    <TableComponent
                        headers={[
                            {
                                name: "Entity Type",
                                type: "text",
                                key: "entity_type",
                                sort: true
                            },
                            {
                                name: "Notification Type",
                                type: "text",
                                key: "notification_type",
                                sort: true,
                                // formatNumberWithComas: true
                            },
                            {
                                name: "Notification Message",
                                type: "text",
                                key: "message",
                                sort: true
                            },
                            {
                                name: "Notified At",
                                type: "time_stamp",
                                key: "created_at",
                                sort: true
                            },
                            // {
                            //     name: "Last Updated At",
                            //     type: "time_stamp",
                            //     key: "updated_at",
                            //     sort: true
                            // },
                            {
                                name: " Action ",
                                type: "button",
                                buttons: [
                                    {
                                        name: "Send Mail",
                                        icon: "./images/icons/ViewEYE.svg",
                                        disable: handleEnable,
                                        action: (data) => {
                                            setNotificationIconClicked(false)
                                            updateNotificationStatus(data)
                                        }
                                    },]
                            }
                        ]}

                        data={userNotifications}
                    />

                </div>
                <Pagination
                    handledPaginationNextClicked={handledPaginationNextClicked}
                    handledPaginationPrevClicked={handledPaginationPrevClicked}
                    isApplyClicked
                    totalRecords={totalRecords}
                    recordsPerPage={RECORDS_PER_PAGE_METER_MASTER}
                    currentPaginationPage={currentPaginationPage}
                />


            </div>
            {isLoading && <Loader />}
            <>
                <Footer />
            </>
        </>
    )
}

